'use strict';

var helpers = require('../helpers/index');

module.exports = {
	/**
	 * @private
	 */
	_set: function(scope, values) {
		return helpers.merge(this[scope] || (this[scope] = {}), values);
	}
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/chart.js/src/core/core.defaults.js
 ** module id = ./node_modules/chart.js/src/core/core.defaults.js
 ** module chunks = 0
 **/